import { createStore, type StoreApi } from 'zustand/vanilla';

import { type GuidedVariantEditId } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentGuidedVariantEdits';

export type WorkspaceAgentGuidedVariantFlowState = {
  /** Bumped on every `openGuidedVariantFlow` so a canceled wizard remounts instead of no-oping. */
  guidedVariantFlowInstanceId: number;
  guidedVariantFlowInitialEdit: GuidedVariantEditId | null;
  isGuidedVariantFlowOpen: boolean;
  closeGuidedVariantFlow: () => void;
  openGuidedVariantFlow: (editId?: GuidedVariantEditId) => void;
};

export type WorkspaceAgentGuidedVariantFlowStore = StoreApi<WorkspaceAgentGuidedVariantFlowState>;

const INITIAL_WORKSPACE_AGENT_GUIDED_VARIANT_FLOW_STATE = {
  guidedVariantFlowInitialEdit: null,
  guidedVariantFlowInstanceId: 0,
  isGuidedVariantFlowOpen: false,
} as const;

/** A fresh store for one panel session. `PrivateWorkspaceAgentGuidedVariantProvider` creates it. */
export const createWorkspaceAgentGuidedVariantFlowStore = (): WorkspaceAgentGuidedVariantFlowStore =>
  createStore<WorkspaceAgentGuidedVariantFlowState>()((set) => ({
    ...INITIAL_WORKSPACE_AGENT_GUIDED_VARIANT_FLOW_STATE,
    closeGuidedVariantFlow: () => set({ isGuidedVariantFlowOpen: false }),
    openGuidedVariantFlow: (editId) =>
      set((state) => ({
        guidedVariantFlowInitialEdit: editId ?? null,
        guidedVariantFlowInstanceId: state.guidedVariantFlowInstanceId + 1,
        isGuidedVariantFlowOpen: true,
      })),
  }));
